// extracted by mini-css-extract-plugin
export var attachment = "_sa-a";
export var emailContainer = "_sa-4";
export var emailContentPaddedContainer = "_sa-b";
export var emailHeader = "_sa-6";
export var emailIframe = "_sa-3";
export var emailInfoIcon = "_sa-9";
export var emailShortenedSummary = "_sa-e";
export var infoDropdown = "_sa-0";
export var infoRowBoundedContent = "_sa-d";
export var internal = "_sa-5";
export var merchant = "_sa-8";
export var messageInputContainer = "_sa-h";
export var normal = "_sa-7";
export var replyCard = "_sa-f";
export var subtleButton = "_sa-1";
export var subtleButtonIconContainer = "_sa-2";
export var toggleViewRepliesButton = "_sa-c";
export var wrappingText = "_sa-g";